<div class="page-layout">
  <app-sidebar></app-sidebar>

  <div class="main-area">
    <app-navbar pageTitle="Timeline" pageSubtitle="Facts that changed over time: each sentence was true from its document's date until the next one."></app-navbar>

    <div class="content-wrap">
      <div class="error-banner" *ngIf="error()">{{ error() }}</div>
      <div class="loading" *ngIf="loading()">Loading the timeline…</div>

      <ng-container *ngIf="!loading() && !error()">
        <app-empty-state *ngIf="chains().length === 0"
          title="No history yet"
          message="When a reviewer marks two sentences as &quot;Both true, at different times&quot; on Version Review, the older one appears here.">
        </app-empty-state>

        <article class="chain-card" *ngFor="let chain of chains()">
          <h3 class="chain-title">{{ chain.current }}</h3>
          <ol class="chain">
            <li class="entry" *ngFor="let entry of chain.entries" [class.current]="entry.isCurrent">
              <span class="dot" aria-hidden="true"></span>
              <div class="entry-body">
                <p class="entry-period">{{ periodLabel(entry) }}<span class="now-chip" *ngIf="entry.isCurrent">current</span></p>
                <p class="entry-text">{{ entry.text }}</p>
                <p class="entry-source">
                  {{ entry.documentName || 'Unknown document' }}
                  <ng-container *ngIf="entry.decision as d">
                    · kept as history by {{ d.decidedBy === 'ai' ? 'the AI review' : (d.reviewedBy || 'a reviewer') }}
                  </ng-container>
                </p>
              </div>
            </li>
          </ol>
        </article>
      </ng-container>
    </div>
  </div>
</div>
